/* Header search (2026-10-02) */
(function () {
  var form = document.querySelector('[data-plxs-form]');
  var input = document.querySelector('[data-plxs-input]');
  var wrap = document.querySelector('[data-plxs]');
  if (!form || !input || !wrap) return;
  var panel = wrap.querySelector('.plxs__panel');
  var defBox = wrap.querySelector('[data-plxs-default]');
  var resBox = wrap.querySelector('[data-plxs-results]');
  var recentBox = wrap.querySelector('[data-plxs-recent]');
  var recentList = wrap.querySelector('[data-plxs-recent-list]');
  var clearBtn = form.querySelector('[data-plxs-clear-input]');
  var KEY = 'plx_search_recent';
  var IDX = 'plxs_idx_v1';
  var timer, ctrl, idxPromise, active = -1, isOpen = false, lastQ = '';
  var FT = 0.3048;

  /* ---------- helpers ---------- */
  function money(n) { return '£' + Number(n).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function short(t) { return String(t || '').split(/\s*[–—]\s+|\s*\|/)[0].trim(); }
  function tokens(q) { return q.toLowerCase().replace(/[^a-z0-9.\s]/g, ' ').split(/\s+/).filter(function (t) { return t.length >= 2; }); }
  function mark(text, toks) {
    var out = esc(text);
    toks.filter(function (t) { return t.length >= 2 && !/^\d/.test(t); }).forEach(function (t) {
      out = out.replace(new RegExp('(^|[^\\w])(' + t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'ig'), '$1<mark>$2</mark>');
    });
    return out;
  }
  function lev(a, b) {
    if (Math.abs(a.length - b.length) > 2) return 9;
    var d = [], i, j;
    for (i = 0; i <= a.length; i++) d[i] = [i];
    for (j = 0; j <= b.length; j++) d[0][j] = j;
    for (i = 1; i <= a.length; i++) for (j = 1; j <= b.length; j++)
      d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
    return d[a.length][b.length];
  }
  function dims(s) {
    var m = String(s || '').match(/(\d+(?:\.\d+)?)\s*m?\s*[x×]\s*(\d+(?:\.\d+)?)\s*m?/i);
    if (!m) return null;
    var a = parseFloat(m[1]), b = parseFloat(m[2]);
    return { a: Math.max(a, b), b: Math.min(a, b) };
  }
  // Size in the query: "4x3", "4 x 3m", "4m by 3m", "12ft x 10ft", "12' x 10'"
  function parseSize(q) {
    var re = /(\d+(?:\.\d+)?)\s*(m|metres?|meters?|ft|feet|foot|')?\s*(?:x|×|by|\*)\s*(\d+(?:\.\d+)?)\s*(m|metres?|meters?|ft|feet|foot|')?/i;
    var m = q.match(re);
    if (!m) return null;
    var ft = /^(ft|feet|foot|')$/i.test(m[2] || '') || /^(ft|feet|foot|')$/i.test(m[4] || '');
    var a = parseFloat(m[1]) * (ft ? FT : 1), b = parseFloat(m[3]) * (ft ? FT : 1);
    return { a: Math.max(a, b), b: Math.min(a, b), raw: m[0], ft: ft, la: m[1], lb: m[3] };
  }

  /* ---------- recent searches ---------- */
  function getRecent() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function saveRecent(q) {
    q = (q || '').trim();
    if (q.length < 2) return;
    try {
      var r = getRecent().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); });
      r.unshift(q);
      localStorage.setItem(KEY, JSON.stringify(r.slice(0, 6)));
    } catch (e) {}
  }
  function paintRecent() {
    var r = getRecent();
    recentBox.hidden = !r.length;
    recentList.innerHTML = r.map(function (q) {
      return '<a class="plxs__chip plxs__chip--recent" data-plxs-item data-plxs-q="' + esc(q) + '" href="/search?q=' + encodeURIComponent(q) + '&type=product">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>' + esc(q) + '</a>';
    }).join('');
  }
  wrap.querySelector('[data-plxs-clear]').addEventListener('click', function () {
    try { localStorage.removeItem(KEY); } catch (e) {}
    paintRecent();
    input.focus();
  });

  /* ---------- catalogue index (sizes + typo fallback) ---------- */
  function loadIndex() {
    if (idxPromise) return idxPromise;
    try {
      var cached = sessionStorage.getItem(IDX);
      if (cached) { idxPromise = Promise.resolve(JSON.parse(cached)); return idxPromise; }
    } catch (e) {}
    idxPromise = fetch('/collections/all?view=plxidx', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (t) {
        var d = JSON.parse(t);
        try { sessionStorage.setItem(IDX, JSON.stringify(d)); } catch (e) {}
        return d;
      })
      .catch(function () { idxPromise = null; return []; });
    return idxPromise;
  }

  function sizeMatches(idx, sz, rest) {
    var words = tokens(rest).filter(function (t) { return !/^(pond|liner|liners|size|sheet|m|ft|x)$/.test(t); });
    var exact = [], cover = {};
    idx.forEach(function (p) {
      if (!p.v || !p.v.length) return;
      var hay = (p.t + ' ' + p.ty + ' ' + p.tg).toLowerCase();
      if (words.length && !words.every(function (w) { return hay.indexOf(w) > -1; })) return;
      p.v.forEach(function (v) {
        if (!v[3]) return;
        var d = dims(v[1]);
        if (!d) return;
        if (Math.abs(d.a - sz.a) < 0.011 && Math.abs(d.b - sz.b) < 0.011) exact.push({ p: p, v: v });
        else if (d.a + 1e-6 >= sz.a && d.b + 1e-6 >= sz.b) {
          var area = d.a * d.b;
          if (!cover[p.h] || area < cover[p.h].area || (area === cover[p.h].area && v[2] < cover[p.h].v[2])) cover[p.h] = { p: p, v: v, area: area };
        }
      });
    });
    // one row per product for exact matches, cheapest option first
    var seen = {};
    exact = exact.sort(function (x, y) { return x.v[2] - y.v[2]; }).filter(function (x) { if (seen[x.p.h]) return false; seen[x.p.h] = 1; return true; });
    var near = Object.keys(cover).map(function (k) { return cover[k]; }).sort(function (x, y) { return x.area - y.area || x.v[2] - y.v[2]; });
    return { exact: exact.slice(0, 8), near: near.slice(0, 6) };
  }

  function fuzzy(idx, q) {
    var toks = tokens(q).filter(function (t) { return t.length >= 3; });
    if (!toks.length) return [];
    return idx.map(function (p) {
      var words = (p.t + ' ' + p.ty + ' ' + p.tg).toLowerCase().replace(/[^a-z0-9.\s]/g, ' ').split(/\s+/);
      var score = 0;
      for (var i = 0; i < toks.length; i++) {
        var t = toks[i], best = 0;
        for (var j = 0; j < words.length; j++) {
          var w = words[j];
          if (!w) continue;
          if (w.indexOf(t) === 0) { best = 3; break; }
          if (t.length >= 4 && lev(t, w.slice(0, t.length + 1)) <= (t.length >= 7 ? 2 : 1)) best = Math.max(best, 2);
        }
        if (!best) return null;
        score += best;
      }
      return { p: p, s: score };
    }).filter(Boolean).sort(function (a, b) { return b.s - a.s || a.p.p - b.p.p; }).slice(0, 6).map(function (x) { return x.p; });
  }

  /* ---------- rendering ---------- */
  function productRow(o, toks) {
    // o: {url,img,title,type,from,max,cmp,label}
    var priceHtml = (o.cmp > o.from ? '<s>' + money(o.cmp) + '</s>' : '') + (o.max > o.from ? '<small>From</small> ' : '') + '<b>' + money(o.from) + '</b>';
    return '<a class="plxs__prod" data-plxs-item href="' + esc(o.url) + '">' +
      '<span class="plxs__prod-img">' + (o.img ? '<img src="' + esc(o.img) + '" alt="" loading="lazy" width="56" height="56">' : '') + '</span>' +
      '<span class="plxs__prod-t"><b>' + mark(o.title, toks) + '</b><small>' + esc(o.label || o.type || '') + '</small></span>' +
      '<span class="plxs__prod-p">' + priceHtml + '</span></a>';
  }

  function render(q, data, idx) {
    var toks = tokens(q);
    var res = (data && data.resources && data.resources.results) || {};
    var prods = (res.products || []);
    var sugg = (res.queries || []).filter(function (s) { return s.text && s.text.toLowerCase() !== q.toLowerCase(); }).slice(0, 5);
    var colls = (res.collections || []).slice(0, 4);
    var arts = (res.articles || []).slice(0, 3);
    var sz = parseSize(q);
    var side = '', main = '', fuzzyUsed = false;

    if (sz) { sugg = []; arts = []; }
    if (sugg.length) {
      side += '<div class="plxs__h"><span>Suggestions</span></div><div class="plxs__list">' + sugg.map(function (s) {
        return '<a data-plxs-item data-plxs-q="' + esc(s.text) + '" href="/search?q=' + encodeURIComponent(s.text) + '&type=product"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-4-4"/></svg><span>' + (s.styled_text || esc(s.text)) + '</span></a>';
      }).join('') + '</div>';
    }
    if (colls.length) {
      side += '<div class="plxs__h"><span>Categories</span></div><div class="plxs__list">' + colls.map(function (c) {
        return '<a data-plxs-item href="' + esc(c.url) + '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/><rect x="3" y="14" width="7" height="7" rx="1.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/></svg><span>' + mark(short(c.title), toks) + '</span></a>';
      }).join('') + '</div>';
    }
    if (arts.length) {
      side += '<div class="plxs__h"><span>Guides</span></div><div class="plxs__list">' + arts.map(function (a) {
        return '<a data-plxs-item href="' + esc(a.url) + '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20V3H6.5A2.5 2.5 0 0 0 4 5.5z"/></svg><span>' + mark(short(a.title), toks) + '</span></a>';
      }).join('') + '</div>';
    }

    if (sz && idx && idx.length) {
      var rest = q.replace(sz.raw, ' ');
      var m = sizeMatches(idx, sz, rest);
      var label = sz.ft ? (sz.la + 'ft × ' + sz.lb + 'ft') : (sz.a + 'm × ' + sz.b + 'm');
      if (m.exact.length) {
        main += '<div class="plxs__h"><span>' + esc(label) + ' — in stock</span><em>' + m.exact.length + ' option' + (m.exact.length === 1 ? '' : 's') + '</em></div>';
        main += m.exact.map(function (x) {
          return productRow({ url: '/products/' + x.p.h + '?variant=' + x.v[0], img: x.p.i, title: short(x.p.t), label: x.v[1] + ' · ' + x.p.ty, from: x.v[2] / 100, max: x.v[2] / 100, cmp: 0 }, tokens(rest));
        }).join('');
      } else if (m.near.length) {
        main += '<div class="plxs__h"><span>No exact ' + esc(label) + ' — nearest larger sizes</span></div>';
        main += m.near.map(function (x) {
          return productRow({ url: '/products/' + x.p.h + '?variant=' + x.v[0], img: x.p.i, title: short(x.p.t), label: x.v[1] + ' · ' + x.p.ty, from: x.v[2] / 100, max: x.v[2] / 100, cmp: 0 }, tokens(rest));
        }).join('');
      }
      if (m.exact.length || m.near.length) {
        main += '<a class="plxs__calc" data-plxs-item href="/#liner-calculator">Sizing a pond? Use the liner calculator — it adds depth and overlap for you →</a>';
      }
    }

    var rows = prods.map(function (p) {
      return { url: p.url, img: p.image || (p.featured_image && p.featured_image.url) || '', title: short(p.title), type: p.product_type, from: parseFloat(p.price_min || p.price), max: parseFloat(p.price_max || p.price), cmp: parseFloat(p.compare_at_price_min || 0) };
    });
    if (!rows.length && idx && idx.length) {
      var fz = fuzzy(idx, q);
      if (fz.length) {
        fuzzyUsed = true;
        rows = fz.map(function (p) { return { url: '/products/' + p.h, img: p.i, title: short(p.t), type: p.ty, from: p.p / 100, max: p.P / 100, cmp: p.c / 100 }; });
      }
    }
    if (rows.length) {
      main += '<div class="plxs__h"><span>' + (fuzzyUsed ? 'Did you mean' : 'Products') + '</span></div>' + rows.slice(0, 6).map(function (r) { return productRow(r, toks); }).join('');
    }

    if (!main && !side) {
      resBox.innerHTML = '<div class="plxs__none"><b>No results for “' + esc(q) + '”</b><p>Check the spelling, try a material like <em>EPDM</em> or <em>butyl</em>, or a size like <em>4x3</em>.</p>' +
        '<div class="plxs__chips">' + ['EPDM pond liner', 'Pond underlay', 'Pond pump', 'Pond filter'].map(function (t) {
          return '<a class="plxs__chip" data-plxs-item data-plxs-q="' + esc(t) + '" href="/search?q=' + encodeURIComponent(t) + '&type=product">' + esc(t) + '</a>';
        }).join('') + '</div><p class="plxs__help">Can’t find it? Call <a href="tel:+441282270214">01282 270214</a> or <a href="https://wa.me/447822012977" target="_blank" rel="noopener">WhatsApp us</a>.</p></div>';
    } else {
      resBox.innerHTML = '<div class="plxs__grid' + (side ? '' : ' plxs__grid--solo') + '">' +
        (side ? '<div class="plxs__side">' + side + '</div>' : '') +
        '<div class="plxs__main">' + main + '</div></div>' +
        '<a class="plxs__all" data-plxs-item href="/search?q=' + encodeURIComponent(q) + '&type=product">See all results for “' + esc(q) + '”<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg></a>';
    }
    defBox.hidden = true;
    resBox.hidden = false;
    active = -1;
  }

  function run(q) {
    lastQ = q;
    if (q.length < 2) { defBox.hidden = false; resBox.hidden = true; paintRecent(); active = -1; return; }
    if (ctrl) try { ctrl.abort(); } catch (e) {}
    ctrl = 'AbortController' in window ? new AbortController() : null;
    var sz = parseSize(q);
    var pq = sz ? (q.replace(sz.raw, ' ').trim() || 'pond liner') : q;
    var url = '/search/suggest.json?q=' + encodeURIComponent(pq) +
      '&resources[type]=product,collection,query,article&resources[limit]=6&resources[limit_scope]=each' +
      '&resources[options][fields]=title,product_type,variants.title,tag,vendor';
    resBox.classList.add('is-loading');
    var pSuggest = fetch(url, ctrl ? { signal: ctrl.signal } : {}).then(function (r) { return r.json(); }).catch(function (e) { if (e && e.name === 'AbortError') throw e; return null; });
    var pIdx = loadIndex();
    Promise.all([pSuggest, pIdx]).then(function (x) {
      if (q !== lastQ) return;
      resBox.classList.remove('is-loading');
      var data = x[0];
      if (sz && data && data.resources && data.resources.results) data.resources.results.products = []; // size queries list exact sizes instead
      render(q, data, x[1]);
    }).catch(function () {});
  }

  /* ---------- open / close / position ---------- */
  function mobile() { return window.innerWidth < 750; }
  function place() {
    if (!isOpen || mobile()) { panel.style.top = panel.style.left = panel.style.width = ''; return; }
    var r = form.getBoundingClientRect();
    if (r.bottom < 0) { close(); return; }
    var w = Math.min(880, window.innerWidth - 32);
    var left = Math.max(16, Math.min(r.left, window.innerWidth - w - 16));
    panel.style.top = (r.bottom + 8) + 'px';
    panel.style.left = left + 'px';
    panel.style.width = w + 'px';
  }
  function open() {
    if (isOpen) return;
    isOpen = true;
    wrap.hidden = false;
    input.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('plxs-open');
    if (mobile()) document.documentElement.classList.add('plxs-sheet');
    paintRecent();
    loadIndex();
    place();
  }
  function close() {
    if (!isOpen) return;
    isOpen = false;
    wrap.hidden = true;
    input.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('plxs-open', 'plxs-sheet');
    setActive(-1);
  }

  /* ---------- keyboard ---------- */
  function items() { return Array.prototype.filter.call(panel.querySelectorAll('[data-plxs-item]'), function (el) { return el.offsetParent !== null; }); }
  function setActive(i) {
    var list = items();
    list.forEach(function (el) { el.classList.remove('is-active'); el.removeAttribute('id'); });
    active = i;
    if (i >= 0 && list[i]) {
      list[i].classList.add('is-active');
      list[i].id = 'plxs-active';
      input.setAttribute('aria-activedescendant', 'plxs-active');
      list[i].scrollIntoView({ block: 'nearest' });
    } else input.removeAttribute('aria-activedescendant');
  }

  input.addEventListener('focus', open);
  input.addEventListener('click', open);
  input.addEventListener('input', function () {
    open();
    var q = input.value.trim();
    if (clearBtn) clearBtn.hidden = !input.value;
    clearTimeout(timer);
    timer = setTimeout(function () { run(q); }, 160);
  });
  input.addEventListener('keydown', function (e) {
    var list = items();
    if (e.key === 'ArrowDown') { e.preventDefault(); open(); setActive(Math.min(active + 1, list.length - 1)); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(Math.max(active - 1, -1)); }
    else if (e.key === 'Escape') { close(); input.blur(); }
    else if (e.key === 'Enter' && active >= 0 && list[active]) {
      e.preventDefault();
      saveRecent(list[active].getAttribute('data-plxs-q') || input.value);
      window.location.href = list[active].href;
    }
  });
  form.addEventListener('submit', function (e) {
    var q = input.value.trim();
    if (!q) { e.preventDefault(); input.focus(); return; }
    saveRecent(q);
  });
  panel.addEventListener('click', function (e) {
    var a = e.target.closest('a');
    if (a) saveRecent(a.getAttribute('data-plxs-q') || input.value);
  });
  if (clearBtn) clearBtn.addEventListener('click', function () {
    input.value = '';
    clearBtn.hidden = true;
    run('');
    input.focus();
  });
  wrap.querySelectorAll('[data-plxs-close]').forEach(function (b) { b.addEventListener('click', close); });
  document.addEventListener('mousedown', function (e) {
    if (!isOpen || mobile()) return;
    if (!form.contains(e.target) && !wrap.contains(e.target)) close();
  });
  window.addEventListener('resize', function () {
    if (!isOpen) return;
    document.documentElement.classList.toggle('plxs-sheet', mobile());
    place();
  });
  window.addEventListener('scroll', function () { if (isOpen && !mobile()) place(); }, { passive: true });

  // Keep the query on the search results page
  try {
    var params = new URLSearchParams(location.search);
    if (location.pathname.indexOf('/search') === 0 && params.get('q')) input.value = params.get('q');
    if (clearBtn) clearBtn.hidden = !input.value;
  } catch (e) {}
})();
